import React from 'react';
import config from 'config';
import { NavLink, Link, withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import LangSwitcher from 'components/LangSwitcher';
import * as walletActions from 'store/modules/wallet';
import * as appActions from 'store/modules/app';
import * as authActions from 'store/modules/auth';
import { FaBars } from 'react-icons/fa';
import './Header.scss';

const Header = withRouter(injectIntl(({ location, intl, ...props }) => {
  const dispatch = useDispatch();
  const toggleDrawer = () => dispatch(appActions.toggleDrawer());
  const setMyAssets = assets => dispatch(walletActions.setMyAssets(assets));
  const logout = () => {
    if (
      window.confirm(intl.formatMessage({ id: 'alert.do_you_want_to_log_out' }))
    ) {
      dispatch(authActions.logout());
      setMyAssets([]);
    }
  };
  const { isAuthenticated, memberinfo } = useSelector(state => state.auth);
  const branchInfo = useSelector(state => state.branch);

  return (
    <nav class="header-nav">
      <div class="container">
        <div class="logo">
          <NavLink to="/">
            <img
              src={branchInfo.logo}
              alt="UNIONEX"
            />
          </NavLink>
        </div>
        {branchInfo.partnerInfo.pm_state !== 'JOIN' ? 
        <div class="left-menu">
          <NavLink to="/trade">
            <FormattedMessage id="u.header.exchange" />
          </NavLink>
          <NavLink to="/myinvest">
            <FormattedMessage id="u.header.myinvest" />
          </NavLink>
          <NavLink to="/wallet">
            <FormattedMessage id="u.header.wallet" />
          </NavLink>
          <NavLink to="/mypage">
            <FormattedMessage id="u.header.mypage" />
          </NavLink>
          <NavLink to="/swap/coin">
            스왑
          </NavLink>
          <NavLink to="/cscenter">
            <FormattedMessage id="u.header.cscenter" />
          </NavLink>
          {(branchInfo.linkData ? branchInfo.linkData : []).map(n => n.is_use === 'true' && n.url !== '' ?
            <a href={n.url} target={n.target}>{n.menu}</a> : null
          )}
        </div> : <div class="left-menu">
          <NavLink to="/cscenter">
            <FormattedMessage id="u.header.cscenter" />
          </NavLink>
        </div>}
        <ul class="right-menu">
          <li>
            <LangSwitcher selected={'-'} onChange={v => {}} />
          </li>
          {!isAuthenticated ? (
            <>
              <li>
                <Link to={{
                      pathname: "/account/login",
                      state: { from: location },
                    }}>
                  <FormattedMessage id="u.header.login" />
                </Link>
              </li>
              <li>
                <Link to="/account/signup">
                  <FormattedMessage id="u.header.signup" />
                </Link>
              </li>
            </>
          ) : (
            <>
              <li>
                <FormattedHTMLMessage
                  id="u.header.hello_message"
                  values={{
                    name: memberinfo ? memberinfo.mb_name : ''
                  }}
                />
              </li>
              <li onClick={logout}>
                <a>
                  <FormattedMessage id="u.header.logout" />
                </a>
              </li>
            </>
          )}
        </ul>
        <div class="drawer-toggle-btn" onClick={toggleDrawer}>
          <FaBars size={24} style={{ verticalAlign: 'middle' }} />
        </div>
      </div>
    </nav>
  );
}));

export default Header;
